import { BaseBus } from "./BaseBus";
import { v_LocationDetailBus } from "./v_LocationDetailBus";
import { DateFunctions } from "../static/date-functions";

export class v_DispatchLaborBus extends BaseBus
{
    constructor(busObj: v_DispatchLaborBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updateDt = DateFunctions.getDate(this.updateDt);
        this.startDate = DateFunctions.getDate(this.startDate);
        this.endDate = DateFunctions.getDate(this.endDate);
        this.sageDt = DateFunctions.getDate(this.sageDt);
        if (this.mgrApproved !== true) {
            this.mgrApproved = false;
        }
        if (this.useLocationRate !== true) {
            this.useLocationRate = false;
        }
    }
    CID(): any {
        return this.dispatchLaborId;
    }
    setId(id: any) {
        this.dispatchLaborId = id;
    }
    setParentId(id: any) {
        this.dispatchId = id;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: v_LocationDetailBus = null) {
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    get inFinance(): boolean {
        return DateFunctions.isValidDate(this.sageDt);
    }
    set inFinance(value: boolean) { }

  dispatchLaborId: any;
  dispatchId: any;
  personId: any;
  laborTypeId: any;
  startDate: Date;
  endDate: Date;
  hoursWorked: number;
  isHelper: boolean;
  timeTypeId: any;
  nonPaid: boolean;
  timeTypeName: string;
  laborTypeName: string;
  afterPayroll: boolean;
  useLocationRate: boolean;
  hourlyRate: number;
  overheadRate: number;
  overheadPercent: number;
  fullName: string;
  dispatchNumber: string;
  mgrApproved: boolean;
  sageDt: Date;
  baseUnionId: any;
  timeClassId: any;
  hrsApproved: boolean;
  insertUserId: any;
  insertDt: Date;
  updateUserId: any;
  updateDt: Date;

}
